<template>
  <main>
    <div v-if="loading" class="text-xs-center">
      <v-progress-circular color="primary" size="60" width="5" class="mt-2" indeterminate/>
    </div>

    <p v-else-if="!prenotazioni.length" class="headline text-xs-center mt-3">
      {{ emptyText || $t('prenotazioni.errori.vuoto') }}
    </p>

    <template v-else v-for="(prenotazione, index) in prenotazioni">

      <v-subheader v-if="prenotazione.header" :key="index" class="mt-1 font-weight-bold black--text">
        {{ $d($utils.date.toJs(prenotazione.header), 'short') }}
      </v-subheader>

      <v-subheader v-else-if="prenotazione.travelDuration" :key="index" class="font-weight-bold"
                   :class="!prenotazione.showWarning ? 'black--text' : 'error--text'">
        <v-icon large :color="!prenotazione.showWarning ? 'black' : 'error'">unfold_more</v-icon>
        <span>{{ $t('prenotazioni.label.percorso_previsto') }}: </span>
        <span class="ml-4">{{ prenotazione.travelDuration.text }}</span>
        <span class="ml-2">({{ prenotazione.travelDistance.text }})</span>
        <v-tooltip v-if="prenotazione.showWarning" bottom>
          <v-icon class="ml-4" color="error" slot="activator">
            error
          </v-icon>
          <span class="text-pre-line ">{{ $t('prenotazioni.errori.route_fuori_tempo', [prenotazione.travelDuration.text, prenotazione.availableTime.text]) }}</span>
        </v-tooltip>
      </v-subheader>

      <v-card v-else ripple hover :key="index" :id="'p' + prenotazione.id"
              class="prenotazione-item mb-1" :class="prenotazioneActiveId === prenotazione.id ? 'prenotazione-item--active' : ''"
              @click.native="showInfoMenu(prenotazione.id, prenotazione)">

        <div v-if="prenotazione.color" class="prenotazione-item__color" :style="'background-color:' + prenotazione.color">
          <span class="ma-auto">{{ prenotazione.index }}</span>
        </div>

        <v-card-text class="pl-4">
          <div class="pb-2">
            <div class="badge" :class="prenotazione.pendente !== 0 ? 'warning' : 'success'"></div>
            <b class="title font-weight-bold">{{ prenotazione.ora_controllo }}</b>
            <span class="title ml-3">{{ (a => a ? a.ragione_sociale : '-') ($store.getters.getAgricoltoreById(prenotazione.id_agricoltore)) }}</span>
            <v-btn v-if="!$store.getters.isAbbonamentoExpired" icon large absolute right @click.stop="showDeleteConfirmDialog(prenotazione.id)">
              <v-icon>clear</v-icon>
            </v-btn>
          </div>
          <div v-if="!showTecnico"><b>{{ $t('prenotazioni.label.note') }}: </b> {{ prenotazione.note || '-' }}</div>
          <div v-else>
            <b>{{ $t('label.tecnico') }}: </b>
            <span>{{ (t => t ? t.nome_cognome : '-') ($store.getters.getTecnicoById(prenotazione.id_tecnico)) }}</span>
          </div>
        </v-card-text>
      </v-card>
    </template>

    <prenotazione-edit-dialog
      ref="prenotazioneEditDialog"
      @success="$emit('change')"/>

    <prenotazione-info-menu
      ref="prenotazioneInfoMenu"
      @close="onCloseInfoMenu"
      @click:edit="showEditDialog"/>

  </main>
</template>
<script>
import PrenotazioneInfoMenu from '@/components/PrenotazioneInfoMenu'
import PrenotazioneEditDialog from '@/components/PrenotazioneDialog'

export default {
    name: 'PrenotazioniList',
    components: { PrenotazioneEditDialog, PrenotazioneInfoMenu },
    props: {
        prenotazioni: {
            type: Array,
            default: () => []
        },
        loading: Boolean,
        emptyText: String,
        showTecnico: Boolean
    },
    data: () => ({
        prenotazioneActiveId: -1
    }),
    methods: {
        showCreateDialog (data_controllo = null) {
            this.$refs.prenotazioneEditDialog.showCreate({ data_controllo: data_controllo })
        },
        showEditDialog (data) {
            this.$refs.prenotazioneEditDialog.showEdit(data)
        },
        showInfoMenu (id, data) {
            this.prenotazioneActiveId = id
            this.$refs.prenotazioneInfoMenu.showInfo('p' + id, data)
            this.$emit('click:item', id)
        },
        closeInfoMenu () {
            this.$refs.prenotazioneInfoMenu.close()
        },
        onCloseInfoMenu () {
            this.prenotazioneActiveId = -1
        },
        showDeleteConfirmDialog (id) {
            this.$confirmDialog.show(id, this.$t('messaggi.conferma_eliminazione'), this.deletePrenotazione)
        },
        deletePrenotazione (id) {
            this.$api.prenotazioni.delete(id)
                .then(response => {
                    this.$snackbar.show(this.$t('prenotazioni.messaggi.eliminato'), 'success')
                    this.$emit('change')
                }).catch(e => {
                    if (e.response && e.response.status === 404 && e.response.data.message === 'in use') {
                        this.$snackbar.show(this.$t('prenotazioni.errori.riferimenti_attivi_delete'), 'error')
                    } else {
                        this.$snackbar.showServerError(e)
                    }
                })
        }
    }
}
</script>
<style lang="scss" scoped>
  .badge {
    height: 12px;
    width: 12px;
    border-radius: 50%;
    display: inline-block;
    margin: 0 6px;
  }

  .prenotazione-item {
    &--active {
      background-color: #d6d6d6;
    }

    .prenotazione-item__color {
      position: absolute;
      display: flex;
      align-items: center;
      background-color: black;
      color: white;
      text-align: center;
      min-width: 22px;
      height: 100%;
      border-radius: 2px 0 0 2px !important;
    }
  }

</style>
